<template>
  <div class="user-info bg-white border border-border rounded-md lg:mb-5 mb-4">
    <div class="flex w-full border-b border-border !m-0 p-4 gap-[8px] items-center">
      <span class="number-badge">
        <span v-if="(state.opt_type!='general' && state.opt_type!='SEIU721')">3</span>
        <span v-if="(state.opt_type=='general' || state.opt_type=='SEIU721')">4</span>
      </span>
      <h2 class="card-title !m-0">{{ isStudentFlow ? "Student's Information" : 'Your Information' }}</h2>
    </div>
    <div class="p-4">
      <div class="form-group mb-4">
        <label for="first_name" class="field-label font-normal text-mute text-sm mb-2 inline-block">First Name<span
            class="required-asterisk text-error">*</span></label>
        <input id="first_name" type="text" placeholder="Enter First Name" class="form" v-model="localForm.first_name"
          @blur="updateParent('first_name')" autocomplete="given-name" :disabled="state.opt_type=='mdsid'"/>
        <small v-if="validation.user_form.first_name.$error" class="text-error text-xs">
          First name is required.
        </small>
      </div>
      <div class="form-group mb-4">
        <label for="last_name" class="field-label font-normal text-mute text-sm mb-2 inline-block">Last Name<span
            class="required-asterisk text-error">*</span></label>
        <input id="last_name" type="text" placeholder="Enter Last Name" autocomplete="family-name" class="form" v-model="localForm.last_name"
          @blur="updateParent('last_name')" :disabled="state.opt_type=='mdsid'"/>
        <small v-if="validation.user_form.last_name.$error" class="text-error text-xs">
          Last name is required.
        </small>
      </div>
      <div class="form-group mb-4" v-if="state.opt_type=='mdsid'">
        <label for="mdsId" class="field-label font-normal text-mute text-sm mb-2 inline-block">MDS ID#<span
            class="required-asterisk text-error">*</span></label>
        <input id="mdsId" type="text" placeholder="Enter MDS ID#" class="form" v-model="localForm.mdsId"
          @blur="updateParent('mdsId')" disabled/>

      </div>
      <!-- <div class="form-group mb-4" v-if="state.payment_method=='Payroll' && state.payroll_enrollment=='1'">
        <label class="font-normal text-mute text-sm mb-2 inline-block">Spouse Name<span
          class="text-error">*</span></label>
        <input type="text" placeholder="Enter Spouse Name" autocomplete="spouse_name" class="form" v-model="localForm.spouse_name"
          @blur="updateParent('spouse_name')" />
          <small v-if="validation.user_form.spouse_name.$error" class="text-error text-xs">
          Spouse Name is required.
        </small>
      </div> -->
      <div class="form-group mb-4" v-if="state.ssn_required=='1' || state.ssn_required==1">
        <label id="ssn-label" for="ssn" class="field-label font-normal text-mute text-sm mb-2 inline-block">
          Social Security Number<span class="required-asterisk text-error">*</span>
        </label>
        <InputMask
          mask="999-99-9999"
          id="ssn"
          inputmode="numeric"
          type="tel"
          autoClear="false"
          :unmask="false"
          :pt="{
            input: {
              id: 'ssn',
              'aria-labelledby': 'ssn-label'
            }
          }"
          :inputProps="{
            inputmode: 'numeric',
            autocomplete: 'off'
          }"
          placeholder="Enter Social Security Number"
          class="form-mask"
          v-model="localForm.ssn"
          @blur="updateParent('ssn')"
        />
       
        <small v-if="validation.user_form.ssn.$error" class="text-error text-xs">
          SSN is required.
        </small>
      </div>
      <div class="form-group mb-4" v-if="state.opt_type=='mdsid'">
          <fieldset role="radiogroup">
            <legend class="field-label font-normal text-mute text-sm mb-2 inline-block">
              Gender?<span class="required-asterisk text-error">*</span>
            </legend>
            <div class="field-radio-block">
              <label class="radio radio-outline-primary field-radio !mb-0">
                <input type="radio"
                  @change="updateParent('gender')" v-model="localForm.gender" name="gender"
                  value="male" /><span>Male</span><span class="checkmark"></span>
              </label>
            </div>
            <div class="field-radio-block">
              <label class="radio radio-outline-primary field-radio !mb-0">
                <input type="radio" name="gender" v-model="localForm.gender" @change="updateParent('gender')"
                  value="female" /><span>Female</span><span class="checkmark"></span>
              </label>
            </div>
          </fieldset>
        </div>
        <div class="form-group mb-4" v-if="state.opt_type=='mdsid'">
        <label for="seaName" class="field-label font-normal text-mute text-sm mb-2 inline-block">State Edu. Assoc.</label>
        <input id="seaName" type="text" placeholder="State Edu. Assoc." class="form" v-model="localForm.seaName"
          @blur="updateParent('seaName')" disabled/>
      </div>
      <div class="form-group mb-4" v-if="state.opt_type=='mdsid'">
        <label for="seaNumber" class="field-label font-normal text-mute text-sm mb-2 inline-block">State Edu. Assoc. ID#</label>
        <input id="seaNumber" type="text" placeholder="State Edu. Assoc. ID#" class="form" v-model="localForm.seaNumber"
          @blur="updateParent('seaNumber')" disabled/>
      </div>
      <div class="form-group mb-4" v-if="state.opt_type=='mdsid'">
        <label for="seiuLocalName" class="field-label font-normal text-mute text-sm mb-2 inline-block">Name of Local</label>
        <input id="seiuLocalName" type="text" placeholder="Name of Local" class="form" v-model="localForm.seiuLocalName"
          @blur="updateParent('seiuLocalName')" disabled/>
          <small v-if="validation.user_form.seiuLocalName.$error" class="text-error text-xs">
            Name of Local is required.
        </small>
      </div>
      <div class="form-group mb-4" v-if="state.opt_type=='mdsid'">
        <label for="seiuLocalNumber" class="field-label font-normal text-mute text-sm mb-2 inline-block">Local ID#</label>
        <input id="seiuLocalNumber" type="text" placeholder="Local ID#" class="form" v-model="localForm.seiuLocalNumber"
          @blur="updateParent('seiuLocalNumber')" disabled/>
      </div>
      <div class="form-group mb-4"  v-if="!(state.employee_id_required != '1' || state.enroll_option == 'individual')">
        <label for="employee_id" class="field-label font-normal text-mute text-sm mb-2 inline-block">Employee ID<span
            class="required-asterisk text-error">*</span></label>
        <input id="employee_id" type="text" placeholder="Employee ID" class="form" v-model="localForm.employee_id"
          @blur="updateParent('employee_id')" />
        <small v-if="validation.user_form.employee_id.$error" class="text-error text-xs">
          Employee ID is required.
        </small>
      </div>
      <div class="form-group mb-4">
        <label for="email" class="field-label font-normal text-mute text-sm mb-2 inline-block">Email Address<span
            class="required-asterisk text-error">*</span></label>
        <input id="email" type="text" placeholder="Enter Email Address" autocomplete="email" class="form" v-model="localForm.email" @input="localForm.email = localForm.email.trim()" @blur="updateParent('email')" />
        <small v-if="validation.user_form.email.$error && !validation.user_form.email.email.$invalid" class="text-error text-xs">
          Email ID is required.
        </small>
        <small v-if="validation.user_form.email.email.$invalid" class="text-error text-xs">
          Enter valid email format.
        </small>
        
      </div>
      
      <div class="form-group mb-4">
        <label id="phone-label" for="phone" class="field-label font-normal text-mute text-sm mb-2 inline-block">Phone Number<span
            class="required-asterisk text-error">*</span></label>
        <div class="flex items-center gap-4">
          <label class="checkbox checkbox-outline-primary !mb-0 w-1/3">
            <input type="checkbox" v-model="localForm.cell" true-value="true" false-value="false" /><span>This is Cell number</span><span class="checkmark"></span>
          </label>
          <div class="flex-1">
            <InputMask mask="(999)999-9999" class="form-mask"
            id="phone"
            placeholder="Enter Phone Number" autoClear="false"
          :unmask="false"  
          :pt="{
            input: {
              id: 'phone',
              'aria-labelledby': 'phone-label'
            }
          }"
          :inputProps="{
        inputmode: 'numeric',
        autocomplete: 'tel',
        'aria-labelledby': 'phone-label'
      }" inputmode="numeric" type="tel" @blur="updateParent('phone')" v-model="localForm.phone" />
            <small v-if="validation.user_form.phone.$error" class="text-error text-xs">
                Phone No. is required.
              </small>
          </div>
        </div>
      </div>
      <div class="form-group mb-4">
        <label id="dob-label" for="date_of_birth" class="field-label font-normal text-mute text-sm mb-2 inline-block">
          Date of Birth<span class="required-asterisk text-error">*</span>
        </label>
        <InputMask
          mask="99/99/9999"
          id="date_of_birth"
          type="tel"
          inputmode="numeric"
          autoClear="false"
          :unmask="false"
          :pt="{
            input: {
              id: 'date_of_birth',
              'aria-labelledby': 'dob-label'
            }
          }"
          :inputProps="{
            inputmode: 'numeric',
            autocomplete: 'tel'
          }"
          class="form-mask"
          placeholder="MM/DD/YYYY"
          v-model="localForm.date_of_birth"
          @blur="updateParent('date_of_birth')"
        />
        <small v-if="validation.user_form.date_of_birth.required.$invalid && validation.user_form.date_of_birth.$error" class="text-error text-xs">
          Date of Birth is required.
        </small>
    
        <small v-if="validation.user_form.date_of_birth.futureDate.$invalid && !validation.user_form.date_of_birth.required.$invalid && validation.user_form.date_of_birth.$error" class="text-error text-xs">
          Please enter valid date
        </small>
      </div>
      <div class="form-group mb-4" v-if="state.cdl_plan">
        <label for="driv_lic_state" class="field-label font-normal text-mute text-sm mb-2 inline-block">Driver License Issue State<span class="required-asterisk text-error">*</span></label>
        <input id="driv_lic_state" type="text" placeholder="Enter Driver License Issue State" class="form" v-model="localForm.driv_lic_state"
          @blur="updateParent('driv_lic_state')" />
        <small v-if="validation.user_form.driv_lic_state.$error" class="text-error text-xs">
          Licence State is required.
        </small>
      </div>
      <div class="form-group mb-4" v-if="state.cdl_plan">
        <label for="driv_license" class="field-label font-normal text-mute text-sm mb-2 inline-block">Driver License ID<span class="required-asterisk text-error">*</span></label>
        <input id="driv_license" type="text" placeholder="Enter Driver License ID" class="form" v-model="localForm.driv_license"
          @blur="updateParent('driv_license')" />
        <small v-if="validation.user_form.driv_license.$error" class="text-error text-xs">
          Licence ID is required.
        </small>
      </div>
      <div class="form-group mb-4" v-if="(state.opt_type === 'direct_page' && state.company_number === '9001204') || state.opt_type=='mdsid'">
        <label for="occupation" class="field-label font-normal text-mute text-sm mb-2 inline-block">Occupation<span class="required-asterisk text-error">*</span></label>
        <!-- <select 
          class="form-mask" 
          v-model="localForm.occupation" 
          @change="updateParent('occupation')"
        >
          <option value="">Select Occupation</option>
          <option 
            v-for="occupation in state.occupations" 
            :key="occupation.key" 
            :value="occupation.key"
          >
            {{ occupation.value }}
          </option>
        </select> -->
        <input 
          id="occupation"
          type="text" 
          placeholder="Enter other occupation" 
          class="form" 
          v-model="localForm.occupation" 
          @blur="updateParent('occupation')" 
        />
        <small v-if="validation.user_form.occupation.$error" class="text-error text-xs">
          Occupation is required.
        </small>
      </div>
      <!-- <div class="form-group mb-4" v-if="(localForm.occupation === 'other' && state.company_number === '9001204') || (localForm.occupation === 'other' &&  state.opt_type=='mdsid')">
        <label class="font-normal text-mute text-sm mb-2 inline-block">Other<span class="text-error">*</span></label>
        <input 
          type="text" 
          placeholder="Enter other occupation" 
          class="form" 
          v-model="localForm.other_occupation" 
          @blur="updateParent('other_occupation')" 
        />
        <small v-if="validation.user_form.other_occupation.$error" class="text-error text-xs">
          Other occupation is required.
        </small>
      </div> -->
      <div class="form-group mb-4" v-if="state.opt_type === 'direct_page' && state.company_number === '9001204'">
        <label for="bank_branch" class="field-label font-normal text-mute text-sm mb-2 inline-block">Primary Banking Branch<span class="required-asterisk text-error">*</span></label>
        <select 
          id="bank_branch"
          class="form-mask" 
          v-model="localForm.bank_branch" 
          @change="updateParent('bank_branch')"
        >
          <option value="">Select Branch</option>
          <option 
            v-for="branch in state.branches" 
            :key="branch.key" 
            :value="branch.key"
          >
            {{ branch.value }}
          </option>
        </select>
    </div>
      <div class="form-group mb-4" v-if="isStudentFlow">
        <label for="school_name" class="field-label font-normal text-mute text-sm mb-2 inline-flex items-center gap-1">
          <span>School Name<span class="required-asterisk text-error">*</span></span>
          <span class="school-info-tooltip group">
            <button
              type="button"
              class="school-info-trigger"
              aria-describedby="school-name-tooltip"
              :aria-label="schoolTooltip"
            >
              <span class="school-info-icon" aria-hidden="true">i</span>
            </button>
            <span id="school-name-tooltip" role="tooltip" class="school-info-popover">
              <span class="school-info-popover__title">{{ schoolTooltipTitle }}</span>
              <span class="school-info-popover__body">{{ schoolTooltipBody }}</span>
            </span>
          </span>
        </label>
        <div class="school-search-wrap">
          <input
            ref="schoolNameInput"
            id="school_name"
            type="text"
            placeholder="Enter school name"
            class="form"
            v-model="localForm.school_name"
            autocomplete="organization"
            role="combobox"
            aria-autocomplete="list"
            :aria-expanded="showSchoolSuggestions ? 'true' : 'false'"
            :aria-activedescendant="schoolActiveIndex >= 0 ? `school-option-${schoolActiveIndex}` : undefined"
            aria-controls="school-name-suggestions"
            @input="onSchoolNameInput"
            @focus="onSchoolNameFocus"
            @blur="onSchoolNameBlur"
            @keydown="onSchoolNameKeydown"
          />
          <ul
            v-if="showSchoolSuggestions && schoolSuggestions.length"
            id="school-name-suggestions"
            class="school-suggestions"
            :class="{ 'school-suggestions--above': schoolSuggestionsOpenAbove }"
            :style="schoolSuggestionsStyle"
            role="listbox"
          >
            <li
              v-for="(school, index) in schoolSuggestions"
              :id="`school-option-${index}`"
              :key="`${school}-${index}`"
              role="option"
              :class="{ 'school-suggestions__option--active': index === schoolActiveIndex }"
              :aria-selected="index === schoolActiveIndex ? 'true' : 'false'"
              @mousedown.prevent="selectSchoolName(school)"
              @mouseenter="schoolActiveIndex = index"
            >
              {{ school }}
            </li>
          </ul>
        </div>
        <small v-if="validation.user_form.school_name?.$error" class="text-error text-xs">
          School name is required.
        </small>
      </div>
    </div>
  </div>
</template>

<script>
import InputMask from "primevue/inputmask"; // Validation mask
import { searchUniversitySuggestions } from "@/utils/universitySearch.js";

import { isStudentFlow as checkStudentFlow } from "@/utils/enrollmentFlow";

const SCHOOL_TOOLTIP_TITLE = "How Should I Enter My School Name?";
const SCHOOL_TOOLTIP_BODY =
  "Type the name of your school and select it from the drop-down choices. If your school name is not available, type the complete name of the school.";

export default {
  name: "UserInfoSection",
  props: {
    user_form: {
      type: Object,
    },
    state: {
      type: Object,
    },
    validation: {
      type: Object
    },
  },
  components:{
    InputMask
  },
  data() {
    return {
      localForm: this.user_form, // Create a local copy of the form
      validationState: {},
      schoolTooltipTitle: SCHOOL_TOOLTIP_TITLE,
      schoolTooltipBody: SCHOOL_TOOLTIP_BODY,
      schoolTooltip: `${SCHOOL_TOOLTIP_TITLE} ${SCHOOL_TOOLTIP_BODY}`,
      schoolSuggestions: [],
      showSchoolSuggestions: false,
      schoolSearchTimer: null,
      schoolSearchRequestId: 0,
      schoolSuggestionsOpenAbove: false,
      schoolSuggestionsStyle: {},
      schoolActiveIndex: -1,
    };
  },
  mounted() {
    this._onSchoolSuggestionsReposition = () => {
      if (this.showSchoolSuggestions) {
        this.updateSchoolSuggestionsPosition();
      }
    };
    window.addEventListener("resize", this._onSchoolSuggestionsReposition);
    window.addEventListener("scroll", this._onSchoolSuggestionsReposition, true);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this._onSchoolSuggestionsReposition);
    window.removeEventListener("scroll", this._onSchoolSuggestionsReposition, true);
  },
  computed: {
    isStudentFlow() {
      return checkStudentFlow(this.state);
    },
  },
  methods: {
    updateSchoolSuggestionsPosition() {
      const input = this.$refs.schoolNameInput;
      if (!input) return;

      const rect = input.getBoundingClientRect();
      const maxHeight = 220;
      const gap = 4;
      const spaceBelow = window.innerHeight - rect.bottom - gap;
      const spaceAbove = rect.top - gap;
      const preferredHeight = Math.min(maxHeight, this.schoolSuggestions.length * 42 + 8);
      const openAbove = spaceBelow < preferredHeight && spaceAbove > spaceBelow;

      this.schoolSuggestionsOpenAbove = openAbove;

      if (openAbove) {
        this.schoolSuggestionsStyle = {
          left: `${rect.left}px`,
          width: `${rect.width}px`,
          bottom: `${window.innerHeight - rect.top + gap}px`,
          maxHeight: `${Math.min(maxHeight, Math.max(spaceAbove, 120))}px`,
        };
        return;
      }

      this.schoolSuggestionsStyle = {
        left: `${rect.left}px`,
        width: `${rect.width}px`,
        top: `${rect.bottom + gap}px`,
        maxHeight: `${Math.min(maxHeight, Math.max(spaceBelow, 120))}px`,
      };
    },
    showSchoolSuggestionsList() {
      this.showSchoolSuggestions = true;
      this.$nextTick(() => {
        this.updateSchoolSuggestionsPosition();
      });
    },
    scrollSchoolSuggestionIntoView() {
      const activeOption = document.getElementById(`school-option-${this.schoolActiveIndex}`);
      activeOption?.scrollIntoView({ block: "nearest" });
    },
    onSchoolNameKeydown(event) {
      if (!this.schoolSuggestions.length) {
        return;
      }

      if (event.key === "ArrowDown") {
        event.preventDefault();
        if (!this.showSchoolSuggestions) {
          this.showSchoolSuggestionsList();
        }
        this.schoolActiveIndex =
          this.schoolActiveIndex < this.schoolSuggestions.length - 1
            ? this.schoolActiveIndex + 1
            : 0;
        this.$nextTick(() => this.scrollSchoolSuggestionIntoView());
        return;
      }

      if (event.key === "ArrowUp") {
        event.preventDefault();
        if (!this.showSchoolSuggestions) {
          this.showSchoolSuggestionsList();
        }
        this.schoolActiveIndex =
          this.schoolActiveIndex > 0
            ? this.schoolActiveIndex - 1
            : this.schoolSuggestions.length - 1;
        this.$nextTick(() => this.scrollSchoolSuggestionIntoView());
        return;
      }

      if (event.key === "Enter" && this.showSchoolSuggestions && this.schoolActiveIndex >= 0) {
        event.preventDefault();
        this.selectSchoolName(this.schoolSuggestions[this.schoolActiveIndex]);
        return;
      }

      if (event.key === "Escape") {
        event.preventDefault();
        this.showSchoolSuggestions = false;
        this.schoolActiveIndex = -1;
      }
    },
    updateParent(field) {
      // Emit the updated value to the parent
      this.$emit("update:user_form", {
        ...this.localForm,
        [field]: this.localForm[field],
      });
      if (this.validation.user_form[field]?.$touch) {
        this.validation.user_form[field].$touch();
      }
      const hasError = this.validation.user_form[field]?.$error || false;
      this.validationState[field] = hasError;
    },
    onSchoolNameInput() {
      this.updateParent("school_name");
      const query = (this.localForm.school_name || "").trim();
      clearTimeout(this.schoolSearchTimer);

      if (query.length < 2) {
        this.schoolSuggestions = [];
        this.showSchoolSuggestions = false;
        this.schoolActiveIndex = -1;
        return;
      }

      this.schoolActiveIndex = -1;

      this.schoolSearchTimer = setTimeout(async () => {
        const requestId = ++this.schoolSearchRequestId;
        const results = await searchUniversitySuggestions(query);
        if (requestId !== this.schoolSearchRequestId) return;
        this.schoolSuggestions = results;
        if (results.length > 0) {
          this.schoolActiveIndex = -1;
          this.showSchoolSuggestionsList();
        } else {
          this.showSchoolSuggestions = false;
          this.schoolActiveIndex = -1;
        }
      }, 300);
    },
    onSchoolNameFocus() {
      if (this.schoolSuggestions.length) {
        this.showSchoolSuggestionsList();
      }
    },
    onSchoolNameBlur() {
      setTimeout(() => {
        this.showSchoolSuggestions = false;
        this.schoolActiveIndex = -1;
        this.updateParent("school_name");
      }, 150);
    },
    selectSchoolName(name) {
      this.localForm.school_name = name;
      this.showSchoolSuggestions = false;
      this.schoolActiveIndex = -1;
      this.updateParent("school_name");
    },
  }
};
</script>

<style scoped>
/* WCAG: increase contrast for field labels in this section only */
.user-info .field-label {
  color: #595959 !important;
}

/* WCAG: increase contrast for required asterisk only */
.user-info .required-asterisk {
  color: #b00020 !important;
}

/* WCAG: increase contrast for validation error text only */
.user-info :deep(small.text-error) {
  color: #b00020 !important;
}

.school-info-tooltip {
  position: relative;
  display: inline-flex;
  vertical-align: text-top;
  margin-top: 1px;
}

.school-info-trigger {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  padding: 0;
  border: 0;
  border-radius: 9999px;
  background: transparent;
  cursor: help;
  transition: background-color 0.15s ease;
}

.school-info-trigger:hover,
.school-info-trigger:focus-visible {
  background: rgba(206, 76, 41, 0.1);
  outline: none;
}

.school-info-trigger:focus-visible {
  box-shadow: 0 0 0 2px #fff, 0 0 0 3px rgba(206, 76, 41, 0.35);
}

.school-info-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 15px;
  height: 15px;
  border: 1px solid #ce4c29;
  border-radius: 50%;
  color: #ce4c29;
  font-size: 10px;
  font-weight: 700;
  line-height: 1;
  font-style: normal;
  font-family: inherit;
  pointer-events: none;
}

.school-info-popover {
  position: absolute;
  top: -12px;
  left: 26px;
  z-index: 50;
  display: block;
  width: min(300px, calc(100vw - 32px));
  overflow: hidden;
  border: 1.5px solid #1a1a1a;
  border-radius: 6px;
  background: #f8fdfd;
  color: #1a1a1a;
  text-align: left;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.12);
  opacity: 0;
  visibility: hidden;
  transform: translateY(-4px);
  transition: opacity 0.15s ease, transform 0.15s ease, visibility 0.15s ease;
  pointer-events: none;
}

.school-info-popover__title {
  display: block;
  padding: 12px;
  background-color: #d9f9f9;
  font-size: 15px;
  line-height: 20px;
  font-weight: 600;
  color: #1a1a1a;
}

.school-info-popover__body {
  display: block;
  padding: 12px;
  background-color: #ffffff;
  font-size: 13px;
  line-height: 18px;
  font-weight: 500;
  color: #1a1a1a;
}

.school-info-tooltip:hover .school-info-popover,
.school-info-tooltip:focus-within .school-info-popover {
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
}

@media (max-width: 991px) {
  .school-info-popover {
    top: calc(100% + 8px);
    left: auto;
    right: 0;
    transform: translateY(-4px);
  }

  .school-info-tooltip:hover .school-info-popover,
  .school-info-tooltip:focus-within .school-info-popover {
    transform: translateY(0);
  }
}

.school-search-wrap {
  position: relative;
}

.school-suggestions {
  position: fixed;
  z-index: 2000;
  overflow-y: auto;
  margin: 0;
  padding: 0;
  list-style: none;
  background: #fff;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.12);
}

.school-suggestions--above {
  box-shadow: 0 -8px 24px rgba(15, 23, 42, 0.12);
}

.school-suggestions li {
  padding: 10px 12px;
  cursor: pointer;
  font-size: 14px;
  color: #1f3341;
}

.school-suggestions li:hover,
.school-suggestions__option--active {
  background: #edf1f8;
}

.school-suggestions__option--active {
  background: #dbe4f2;
}
</style>